<b-tooltip v-bind="$attrs" :auto-close="autoCloseParsed" :triggers="triggersParsed">
	<template #content>
		<slot name="content"/>
	</template>
	<slot/>
</b-tooltip>
